var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam-item"},[_vm._t("default"),_c('p',{staticClass:"exam-item__title"},[_vm._v(_vm._s(_vm.exam.text)+" "+_vm._s(_vm.exam.licenseType ? ("- " + (_vm.exam.licenseType)) : ''))]),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }